export default __webpack_public_path__ + "static/media/whats.7b8c3a51.svg";